function FourColumnDayBookReport() {
    return (
        <div>
            <h2>Four Column Day Book</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default FourColumnDayBookReport;